import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { STORE_STATUS } from '@/constants/store'
import { streamingRestApi } from '@/service/streamingApi'
import { useGeoBlockingTemplatesStore } from '@/stores/useGeoTemplateStore'

import { GeoBlockingTemplate } from '../_legacy/GeoBlocking/types'
import { DataCard } from '../card'
import {
  GeoBlockingTemplateForm,
  GeoBlockingTemplateFormButton
} from '../forms/GeoBlockingTemplateForm'
import { ActionDeleteItem, ActionFormItem, ActionsMenu } from '../table/actions'
import { TableBase } from '../table/base'
import { GET_GEOBLOCKING_TEMPLATE_DGE_TABLE_COLUMNS } from './geoBlockingTemplates.dge.table'
import { createPopulatedTemplateMap } from './GeoBlockingTemplatesList.helpers'

const GeoBlockingTemplatesList = () => {
  const {
    data: templates,
    fetchData,
    resetState
  } = useGeoBlockingTemplatesStore(
    useShallow((state) => ({
      data: state.data,
      isLoading: state.status === STORE_STATUS.loading,
      isFetching: state.status === STORE_STATUS.fetching,
      fetchData: state.fetchData,
      useGeoBlockingTemplatesStore,
      resetState: state.resetState
    }))
  )

  useEffect(() => {
    fetchData()
    return resetState
  }, [fetchData])

  const templateLocationMap = createPopulatedTemplateMap(templates)

  const handleDelete = async (templateId: number) => {
    await streamingRestApi.endpoints.geoBlockingTemplatesEndpoints.deleteGeoBlockingTemplate(
      templateId
    )
    fetchData()
  }

  return (
    <DataCard
      title="Geo Templates"
      headerPostfixActions={<GeoBlockingTemplateFormButton onSubmit={fetchData} />}
    >
      <TableBase
        data={templates}
        tableId="geo-template"
        columns={GET_GEOBLOCKING_TEMPLATE_DGE_TABLE_COLUMNS(templateLocationMap)}
        rowActions={
          <ActionsMenu>
            <ActionFormItem
              getForm={(template: GeoBlockingTemplate) => (
                <GeoBlockingTemplateForm defaultValues={template} onSubmit={fetchData} />
              )}
              displaySeparately
            />
            <ActionDeleteItem
              onDelete={(template: GeoBlockingTemplate) => handleDelete(template.id)}
              confirmationMessage={(template) =>
                `Are you sure you want to delete Geo Blocking Template ${template.id}?`
              }
              successMessage={(template) =>
                `Successfully deleted Geo Blocking Template ${template.id}`
              }
              errorMessage={(template) => `Error deleting Geo Blocking Template ${template.id}`}
            />
          </ActionsMenu>
        }
        clientSideSortAndPagination
      />
    </DataCard>
  )
}

export default GeoBlockingTemplatesList
